import React from "react";
import Router from "next/router";
import Button from "shared/Button";
import { GridColumn, GridRow } from "emotion-flex-grid";
import { colors } from "styles/colors";
import { BannerWrap, BannerTitle } from "./styled";
/**
 * @component
 * @param {string} description
 * @returns Banner component with about cookie policy
 */
const Banner = ({ description }) => {
  const toSignUp = () => {
    Router.push("/registration");
  };

  return (
    <BannerWrap>
      <GridColumn width={["12", "12"]} mx={("", "auto")}>
        <GridRow justify="center" wrap={["wrap", "nowrap"]} direction={["column", "row"]} align="center">
          <GridColumn width="auto">
            <BannerTitle>{description}</BannerTitle>
          </GridColumn>
          <GridColumn width="auto">
            <Button stylType="primary" color={colors.RED} text="Sign Up" onClick={toSignUp} />
          </GridColumn>
        </GridRow>
      </GridColumn>
    </BannerWrap>
  );
};

export default Banner;
